import { useEffect } from "react";

export interface ShortcutConfig {
  key: string;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  metaKey?: boolean;
  action: () => void;
  description: string;
}

export function useKeyboardShortcuts( shortcuts: ShortcutConfig[] ) {
  useEffect( () => {
    const handleKeyDown = ( e: KeyboardEvent ) => {
      shortcuts.forEach( ( { key, ctrlKey, shiftKey, metaKey, action } ) => {
        const matchesKey = e.key.toLowerCase() === key.toLowerCase();
        const matchesCtrl = ctrlKey ? ( e.ctrlKey || e.metaKey ) : ( !e.ctrlKey && !e.metaKey );
        const matchesShift = shiftKey ? e.shiftKey : !e.shiftKey;
        const matchesMeta = metaKey ? e.metaKey : !e.metaKey;

        if ( matchesKey && matchesCtrl && matchesShift && matchesMeta ) {
          e.preventDefault();
          action();
        }
      } );
    };

    window.addEventListener( "keydown", handleKeyDown );
    return () => window.removeEventListener( "keydown", handleKeyDown );
  }, [ shortcuts ] );
}
